/** 연수 본문 HTML 기본 템플릿 */
export const DEFAULT_TRAINING_CONTENT_HTML = `
<h2>연수 안내</h2>
<p>연수 목표와 진행 방식을 작성해 주세요.</p>
<h2>일정</h2>
<ul>
  <li>시간:</li>
  <li>장소:</li>
</ul>
<h2>준비물</h2>
<ul>
  <li></li>
</ul>
<h2>참고 링크</h2>
<p><a href="https://" target="_blank" rel="noopener noreferrer">링크 제목</a></p>
`.trim();

/** 저장 전 위험 태그·이벤트 핸들러 제거 */
export function sanitizeTrainingHtml(html: string): string {
  return html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
    .replace(/<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi, '')
    .replace(/<embed\b[^>]*>/gi, '')
    .replace(/\s+on\w+\s*=\s*(".*?"|'.*?'|[^\s>]+)/gi, '')
    .replace(/javascript:/gi, '')
    .slice(0, 100_000);
}
